import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { url } from "../../../../configlink";

export default function CorporateDetails() {
  let [data, setData] = useState({
    CorporateName: '',
    CorporateType: '',
    Devision: '',
    Address: '',
    Address2: '',
    City: '',
    State: '00',
    Zip: '',
    Fax: '',
    AccountStatus: ''
  });

  const states = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
  ];

  let [changedData, setChangedData] = useState({})

  let loc = useLocation()
  let id = loc.search.split('=')[1]
  
  useEffect(() => {
    if(id){
      getData(id)
    }
  }, []);

  function getData(x){
    console.log(x);
    try {
      fetch(`${url}/api/admin/getcorporatedetails?id=${x}`, {
        credentials: 'include'
      })
          .then((res) => res.json())
          .then((data) => {
              console.log(data);
              if(data.message === 'success'){
                setData(data.result)
              }        
          })
          .catch(err => {
              console.error(err);  
          })
  } catch (error) {
      console.error(error);
      
  }
  }

  // console.log(changedData);

  function createCorp(){
    console.log(changedData);
    try {
      fetch(`${url}/api/admin/createcorporate`,{
              method:"POST",
              credentials:'include',
              headers:{
                  "Content-Type": "application/json"
              },
              body: JSON.stringify(changedData)
          }
      )
          .then((res) => res.json())
          .then((data) => {
              console.log(data);   
              if(data.message === 'success'){
                  alert("Created successfully")     
                  setData({
                    CorporateName: '',
                    CorporateType: '',
                    Devision: '',
                    Address: '',
                    Address2: '',
                    City: '',
                    State: '00',
                    Zip: '',
                    Fax: '',
                    AccountStatus: ''
                  })                 
              }                 
          })
          .catch(err => {
              console.error(err);  
          })
  } catch (error) {
      console.error(error);
      
  }
  }

  function updateContent(){
    console.log(changedData, id);

    if(Object.keys(changedData).length !== 0){
      // console.log('not empty');
      try {
        fetch(`${url}/api/admin/editcorporate?id=${id}`,{
                method:"PUT",
                headers:{
                    "Content-Type": "application/json"
                },
                credentials: 'include',
                body: JSON.stringify(changedData)
            }
        )
            .then((res) => res.json())
            .then((data) => {
                console.log(data);   
                if(data.message === 'success'){
                    alert("Updated successfully")                   
                }                 
            })
            .catch(err => {
                console.error(err);  
            })
    } catch (error) {
        console.error(error);
    }
    }
    else{
      alert("No changes made")  
    }
    
  }
  

  return (
    <>
    {/* <div>
       <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
        <DialogTitle>Corporate Details</DialogTitle>
        <DialogContent>
          <DialogContentText>
            UserId: 767 (Automatically Assigned)
          </DialogContentText>
          <DialogContentText>
            Oragnization Name: Nicholls State University [Details]
          </DialogContentText>
          <DialogContentText>User Name: dnaskc</DialogContentText>
          <DialogContentText>
            E-mail Address: test123@gmail.com
          </DialogContentText>
          <DialogContentText>Password: *****</DialogContentText>
          <DialogContentText>First Name: </DialogContentText>
          <DialogContentText>Last Name: </DialogContentText>
          <DialogContentText>Sales: </DialogContentText>
          <DialogContentText>FedEx</DialogContentText>
          <DialogContentText>PI: </DialogContentText>
          <DialogContentText>Buildings: </DialogContentText>
          <DialogContentText>Room Number: </DialogContentText>
          <DialogContentText>Address 1: </DialogContentText>
          <DialogContentText>Address 2: </DialogContentText>
          <DialogContentText>City: </DialogContentText>
          <DialogContentText>State: </DialogContentText>
          <DialogContentText>ZIP: </DialogContentText>
          <DialogContentText>Phone Number: </DialogContentText>
          <DialogContentText>Fax: </DialogContentText>
          <DialogContentText>Purchasing Agent: </DialogContentText>
          <DialogContentText>Purchasing Agent Email: </DialogContentText>
          <DialogContentText>Purchasing Agent Phone: </DialogContentText>
          <DialogContentText>Purchasing Agent Address 1: </DialogContentText>
          <DialogContentText>Purchasing Agent Address 2: </DialogContentText>
          <DialogContentText>Purchasing Agent City: </DialogContentText>
          <DialogContentText>Purchasing Agent State: </DialogContentText>
          <DialogContentText>Purchasing Agent Zip: </DialogContentText>
          <DialogContentText>Account Status: Active</DialogContentText>
          <DialogContentText>Internal Comments: </DialogContentText>
          <DialogContentText>Billing Comments:</DialogContentText>
          <DialogContentText>Account Creatd On: </DialogContentText>
          <DialogContentText>Last Login On: </DialogContentText>
          <DialogContentText>Invoice Method: </DialogContentText>
          <DialogContentText>Order Forms: </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close Window</Button>
        </DialogActions>
      </Dialog> 
    </div> */}
    {/* { data && !Array.isArray(data) ? 
    <> */}
    <div className='p-2'>
        <h1 className='text-2xl font-bold'>Corporate Details</h1>
        <div className='border border-black p-2 text-[13px] flex flex-col gap-[5px]'>
            {id && 
            <div className='flex bg-gray-100 py-1 px-2'>
                <p className='min-w-[250px] '>Corporate ID:</p>
                <p className='font-bold'>{id} (Automatically Assgined)</p>
            </div>
            }
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Corporate Name:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.CorporateName} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        CorporateName: e.target.value
                    })
                    setData({...data, CorporateName:e.target.value})
                }}
                />             
            </div>

            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>Corporate Type:</p>
                <select 
                name="corptype" 
                id="corptype" 
                className='w-[100px] border border-black' 
                value={data.CorporateType} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        CorporateType: parseInt(e.target.value)
                    })

                    setData({...data, CorporateType:e.target.value})
                }}
                >
                <option value={""} disabled>Select</option>
                <option value={1}>Private</option>
                <option value={2}>Academy</option>
                <option value={4}>LawFirm</option>
                <option value={5}>BioPharma</option>
                <option value={6}>Government</option>
                <option value={7}>Misc</option>
                </select>
            </div>

            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Devision:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Devision} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        Devision: e.target.value
                    })
                    setData({...data, Devision:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>Address:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Address} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        Address: e.target.value
                    })
                    setData({...data, Address:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Address2:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Address2} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        Address2: e.target.value
                    })
                    setData({...data, Address2:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>City:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.City} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        City: e.target.value
                    })
                    setData({...data, City:e.target.value})
                }}
                />             
            </div>
            
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>State:</p>
                <select name="state" 
                id="state" 
                className='w-[150px] border border-black' 
                value={data.State} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        State: e.target.value
                    })
                    setData({...data, State:e.target.value})
                }}
                >  
                <option value={"00"} disabled>Select</option>
                {states.map((x, i) => (
                <option key={i} value={x.value}>
                  {x.label}
                </option>
              ))}
                </select>           
            </div>
            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>Zip Code:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Zip} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        Zip: e.target.value
                    })
                    setData({...data, Zip:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Phone:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Phone} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        Phone: e.target.value
                    })
                    setData({...data, Phone:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>Fax:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Fax} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        Fax: e.target.value
                    })
                    setData({...data, Fax:e.target.value})
                }}
                />             
            </div>
            
            {id && 
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Account Status:</p>
                <select 
                name="acstatus" 
                id="acstatus" 
                className='w-[100px] border border-black' 
                value={data.AccountStatus} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        AccountStatus: e.target.value
                    })

                    setData({...data, AccountStatus:e.target.value})
                }}
                >
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
                </select>
            </div>
            }

            {id ? 
            <div className='flex justify-center mt-8 text-[14px]'>
                <button 
                onClick={() => updateContent()}
                className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Update Corporate</button>
            </div> :
            <div className='flex justify-center mt-8 text-[14px]'>
                <button 
                onClick={() => createCorp()}
                className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Create Corporate</button>
            </div> 
            }
        </div>

        <div className='flex justify-center mt-8 text-[14px]'>
            <button 
            onClick={() => window.close()}
            className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Close Window</button>
        </div>
    </div>
    </>
    //  :
    //  <p className="p-2">Loading..</p>
    // }
    // </>
  );
}
